import { render, staticRenderFns } from "./taxCargo.vue?vue&type=template&id=3c895212&scoped=true"
import script from "./taxCargo.vue?vue&type=script&lang=js"
export * from "./taxCargo.vue?vue&type=script&lang=js"
import style0 from "./taxCargo.vue?vue&type=style&index=0&id=3c895212&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c895212",
  null
  
)

export default component.exports